import { Duplicate } from "./Duplicate";
import { MoveDown } from "./MoveDown";
import { MoveUp } from "./MoveUp";
import { Remove } from "./Remove";
import { Separator } from "./Separator";

export const BlockActions = Object.assign(
  {},
  {
    MoveUp,
    MoveDown,
    Duplicate,
    Remove,
    Separator,
  },
);
